import { makeStyles, Theme } from '@material-ui/core/styles';
import {cobalt, gainsboro, lightCobalt, orangered, whiteSmoke} from 'styles/abstract/variables';
import checkIcon from 'assets/icons/icon_check.svg';

export const makeExpandIconStyles = makeStyles({
    expandIcon: {
        fill: orangered,
        fontSize: '2rem',
        marginRight: '0.5rem',
        transition: 'all 0.3s ease',

        '&.expand': {
            transform: 'rotate(180deg)',
        },
    },
});

export const makeExpansionPanelStyles = makeStyles({
    root: ({ noBorder }: { noBorder?: boolean, } = {}) => {
        const borderStyles = noBorder
            ? { '&::before': { content: 'none', }, }
            : { border: `1px solid ${gainsboro}`, };

        return Object
            .assign(
                {},
                borderStyles,
            );
    },
}, { index: 1, });

export const makeExpansionPanelDetailsStyles = makeStyles((theme: Theme) => ({
    root: {
        flexDirection: 'column',
        padding: '0 1.5rem 1.5rem 3rem',

        '& a': {
            color: cobalt,
            'textDecoration': 'none',

            '&:hover': {
                color: lightCobalt,
            }
        },

        [theme.breakpoints.down('xs')]: {
            padding: '0 1.5rem 1.5rem',
        },
    },
}));

export const makeExpansionPanelShippingCostStyles = makeStyles((theme: Theme) => ({
    list: {
        margin: 0,
        listStyleType: 'none',
        paddingLeft: 0,
    },
    listItem: {
        background: `url(${checkIcon}) no-repeat top left`,
        fontSize: '0.75rem',
        marginBottom: '0.75rem',
        paddingLeft: '1.5rem',
    },
    logo: {
        marginTop: '0.25rem',
        width: '6rem',
    },
    table: {
        borderCollapse: 'collapse',
        width: '100%',
    },
    tableData: {
        border: `1px solid ${gainsboro}`,
        fontSize: '1rem',
        padding: '0.5rem 1rem',

        '&:first-child': {
            alignItems: 'flex-end',
            background: whiteSmoke,
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
        },

        '&:last-child': {
            alignItems: 'center',
            display: 'flex',
            flex: 0.4,
            justifyContent: 'center',
        },

        [theme.breakpoints.down('xs')]: {
            '&:first-child': {
                alignItems: 'flex-start',
            },
        },
    },
    tableRow: {
        display: 'flex',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
}));

export const makeExpansionPanelSummaryStyles = makeStyles({
    root: {
        padding: '0 0.5rem',
    },
    content: {
        alignItems: 'center',
    },
    expanded: ({ disableTitleMargin = false }: { disableTitleMargin?: boolean } = {}) => Object
        .assign(
            {},
            disableTitleMargin && { margin: '0 !important', }
        )
});

export const makeExpansionPanelTypographyStyles = makeStyles({
    root: {
        fontWeight: 600,
    },
});
